import { Config } from "../Config";
import { ClientDeviceType } from "../UserAgent";

export class MockConfig implements Config {
  public bandwidthUrl = "bandwidthUrl";
  public commandsUrl = "commandsUrl";
  public homePageId = "homePageId";
  public languages = { en: "en" };
  public providers = [];
  public videoUrl = "videoUrl";
  public privateRelay = false;
  public features = {};
  public loginMsisdn = false;
  public deviceKind = ClientDeviceType.DESKTOP;
}
